import { Box, Paper } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useUser } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';
import LoadingScreen from '@sophocles/components/LoadingScreen';
import useCustomer from '@sophocles/hooks/useCustomer';
import useSiteGroup from '@sophocles/hooks/useSiteGroup';
import EnhancedPOPTable from '@sophocles/views/sites/components/EnhancedPOPTable';

// This view is only reachable via the plant-level `/c/:cust_id/plant/:sitegroup_id/pop`
// route (no `:site_id` segment), so it always renders the site-group rollup
// report. The single-site case moved to SiteDashboardPopView, nested under
// SiteDashboardLayout, which sources the site snapshot from layout context.
export function ProofOfPerformanceView(props) {
  const { cust_id, sitegroup_id } = useParams();

  const { customer, loading: customerLoading } = useCustomer(Number(cust_id));
  const { siteGroup, loading: siteGroupLoading, curfew } = useSiteGroup(Number(sitegroup_id));

  const { user } = useUser();
  const { t } = useTranslation();

  const loading = customerLoading || siteGroupLoading;

  const selectedPlantId = siteGroup.get('id', null);

  // Readiness gate: wait until the site group entity matches the URL param.
  if (!siteGroup.get('id') || String(siteGroup.get('id')) !== String(sitegroup_id)) {
    return <LoadingScreen />;
  }

  const pageTitle = t('sites.proofOfPerformance');

  return (
    <AppNav flex notFullHeight loading={loading} page="plant_list" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={pageTitle} />
        <Paper sx={{ mx: 1 }}>
          <EnhancedPOPTable
            customerId={customer.get('id', null)}
            siteGroupId={selectedPlantId}
            siteGroup={siteGroup}
            user={user}
            curfew={curfew}
          />
        </Paper>
      </Box>
    </AppNav>
  );
}

export default ProofOfPerformanceView;
